module.exports = __webpack_public_path__ + "img/marker_normal_focused.7592682b.svg";